import { render, staticRenderFns } from "./Soulcraft.vue?vue&type=template&id=2a43cacc&scoped=true&"
import script from "./Soulcraft.vue?vue&type=script&lang=js&"
export * from "./Soulcraft.vue?vue&type=script&lang=js&"
import style0 from "./Soulcraft.vue?vue&type=style&index=0&id=2a43cacc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a43cacc",
  null
  
)

export default component.exports